import { render, staticRenderFns } from "./card.list.vue?vue&type=template&id=1baab821&"
import script from "./card.list.vue?vue&type=script&lang=js&"
export * from "./card.list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports